/**
 * Narrow an arbitrary string to one of a TypeScript enum's values.
 *
 * Widening the values to `readonly string[]` before the lookup is what keeps
 * this cast-free: `Array<T>.includes` refuses a plain `string` argument, which
 * is why the hand-rolled copies of this guard each reached for `v as never`.
 */
export function isEnumValue<T extends string>(
  enumObject: Record<string, T>,
  value: string,
): value is T {
  const values: readonly string[] = Object.values(enumObject);
  return values.includes(value);
}
